// Page scroll is locked while the search dropdown is open (config.ts `callbacks`). The SDK places the
// panel at the page position of the moment it opened (absolute, `scrollY` + the input's bottom), so
// on desktop, where the SDK locks nothing, scrolling the page carried the panel out of the viewport.
// The SDK's own lock is phones only (`<body>`, below md); light.scss locks `<html>` from md up, and
// the panel scrolls inside itself there (shadow.scss), so nothing behind the lock is out of reach.

export const SEARCH_OPEN_CLASS = "raventic-rc-search-open"; // on <html>, light.scss

export function lockPageScroll(): void {
  document.documentElement.classList.add(SEARCH_OPEN_CLASS);
}

export function unlockPageScroll(): void {
  document.documentElement.classList.remove(SEARCH_OPEN_CLASS);
}
